import { Controller } from "@hotwired/stimulus"

// Handles per-meeting actions on the adjuster meetings list.
// Currently: showing/hiding the "Mark as Completed" modal.
// The modal's form submits normally (data-turbo="false"), so this controller
// only manages the open/closed state of the overlay.
export default class extends Controller {
  static targets = ["completeModal"]
  static classes = ["hidden"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  showCompleteModal(event) {
    if (event) event.preventDefault()
    if (!this.hasCompleteModalTarget) return

    this.completeModalTarget.classList.remove(this.hiddenClassName)
    document.addEventListener("keydown", this.handleKeydown)

    const textarea = this.completeModalTarget.querySelector("textarea")
    if (textarea) textarea.focus()
  }

  hideCompleteModal(event) {
    if (event) event.preventDefault()
    if (!this.hasCompleteModalTarget) return

    this.completeModalTarget.classList.add(this.hiddenClassName)
    document.removeEventListener("keydown", this.handleKeydown)
  }

  // Close when clicking the backdrop (the overlay itself), but not when
  // clicking inside the modal panel.
  backdropClose(event) {
    if (event.target === this.completeModalTarget) {
      this.hideCompleteModal(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hideCompleteModal(event)
    }
  }

  // Falls back to "hidden" when no `data-meeting-actions-hidden-class` is declared.
  get hiddenClassName() {
    return this.hasHiddenClass ? this.hiddenClass : "hidden"
  }
}
